import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { AvcsCell } from '../types';
import type { PaginatedResponse } from '@shared/types';

interface UseAvcsCellsParams {
  page?: number;
  size?: number;
}

export function useAvcsCells(params: UseAvcsCellsParams = {}) {
  const { page = 0, size = 100 } = params;

  const queryParams: Record<string, string> = {
    page: String(page + 1),
    size: String(size),
  };

  return useQuery({
    queryKey: queryKeys.holdingsCells(page, size),
    queryFn: () => apiClient.get<PaginatedResponse<AvcsCell>>('/holdings/avcs/cells', queryParams),
    placeholderData: keepPreviousData,
  });
}
